module.exports = __webpack_public_path__ + "static/media/subICloud1.48457ac8.png";